// extracted by mini-css-extract-plugin
export default {"delimiter":"Delimiter_delimiter__RIMo+"};